// extracted by mini-css-extract-plugin
export var caption = "Image-module--caption--Rmcsz";
export var component = "Image-module--component--5ex0e";
export var credit = "Image-module--credit--mAkTw";
export var link = "Image-module--link--sndd8";